import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from '@services/auth.service';
import {RoutesStorage} from '@helpers/routes.helper';

/**
 * Разрешить Route только если это не Route для текущего пользователя
 */
@Injectable()
export class NotForCurrentUserGuardService implements CanActivate {
    constructor(
        private authService: AuthService,
        private router: Router,
    ) {

    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const id = route.params.id;
        const currentUser = this.authService.user$.getValue();

        const isNotCurrent = Boolean(id && currentUser && +id !== currentUser.id);

        if (isNotCurrent) {
            return true;
        } else {
            this.router.navigate([RoutesStorage.Organization.usersList]);
            return false;
        }
    }
}
